import React, { Component } from 'react';
import { findIndex } from 'lodash';

import withFeatureFlags from '../../hocs/withFeatureFlags';
import { getEventDates, getEventMonths } from '../../../utils/formatting';
import Description from '../../text/Description';
import { LinkAnchor } from '../../Links';
import { getEventRedirectUrl, getUseAnchorForEventLink, getEventLinkTarget } from '../../../utils/events';
import BackgroundImage from '../../BackgroundImage';

const _ = { findIndex };

class FeaturedEventCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dimensions: null,
        };
        this.refCallback = this.refCallback.bind(this);
    }

    refCallback(element) {
        if (element) {
            this.setState({
                dimensions: element.getBoundingClientRect(),
            });
        }
    }

    render() {
        const { force = {}, featureFlags, auth } = this.props;
        const { id, name, published, registeredCount, eventDirectors, eventState, eventLocations, utrType, currentMember, /* club, */ photoImages, source } = this.props.event;
        const { eventSchedule } = this.props.event;

        // const organizer = eventDirectors && eventDirectors.length ? eventDirectors[0].displayName : '';
        const locationCityStateZip = (eventLocations && eventLocations.length > 0) ? eventLocations[0].display || eventLocations[0].placeName : null;

        let eventName = name;
        let eventNameLength = 35;
        if (this.state.dimensions && this.state.dimensions.width) {
            if (this.state.dimensions.width > 300) {
                eventNameLength += 2 * parseInt((this.state.dimensions.width - 300) / 10);
            }
        }
        if (eventName.length > eventNameLength) {
            eventName = `${eventName.substr(0, eventNameLength)}...`;
        }
        const descriptionItems = [locationCityStateZip];
        if (registeredCount > 0 && !force.hideRegisteredCount) {
            descriptionItems.push(`${registeredCount} playing`);
        }
        const isPlaying = currentMember && (currentMember.playing || currentMember.isPlaying);
        const isOrganizer = (auth && auth.user && auth.user.id && eventDirectors && (_.findIndex(eventDirectors, { memberId: auth.user.id }) !== -1)) || (currentMember && currentMember.eventDirectorRole);

        const colorState = () => {
            switch (eventState.value) {
                case 'pre_registration':
                case 'completed':
                    return 'gray';
                case 'registration_closed':
                case 'in_progress':
                    return 'green';
                default:
                    return 'teal';
            }
        };

        const getTag = (block) => {
            if (!published) {
                return <div className={`tag tag-gray tag-sm ${block ? 'tag-block' : ''}`}>Draft</div>;
            }
            if (isPlaying && isOrganizer) {
                return (
                    <React.Fragment>
                        <div className={`tag tag-${colorState()} tag-sm mr8`}>Player</div>
                        <div className={`tag tag-${colorState()} tag-sm`}>Organizer</div>
                    </React.Fragment>
                );
            } if (isPlaying) {
                return <div className={`tag tag-${colorState()} tag-sm ${block ? 'tag-block' : ''}`}>Player</div>;
            } if (isOrganizer) {
                return <div className={`tag tag-${colorState()} tag-sm ${block ? 'tag-block' : ''}`}>Organizer</div>;
            }
            switch (eventState.value) {
                case 'pre_registration':
                    return <div className={`tag tag-gray-outline tag-sm ${block ? 'tag-block' : ''}`}>Pre Reg</div>;
                case 'open_registration':
                    return <div className={`tag tag-teal-outline tag-sm ${block ? 'tag-block' : ''}`}>Open</div>;
                case 'registration_closed':
                    return <div className={`tag tag-green-outline tag-sm ${block ? 'tag-block' : ''}`}>Closed</div>;
                case 'in_progress':
                    return <div className={`tag tag-green-outline tag-sm ${block ? 'tag-block' : ''}`}>In Progress</div>;
                case 'completed':
                    return <div className={`tag tag-gray-outline tag-sm ${block ? 'tag-block' : ''}`}>Completed</div>;
                default:
                    return <div />;
            }
        };

        const hasBackgroundImage = () => {
            return !!(photoImages.default || photoImages.dashboard.oneX);
        };

        return (
            <LinkAnchor href={getEventRedirectUrl(id, source, featureFlags.dualMatchProfileFlag, auth.user)} useAnchor={getUseAnchorForEventLink(source, featureFlags.dualMatchProfileFlag, auth.user)} target={getEventLinkTarget(source, featureFlags.dualMatchProfileFlag, auth.user)}>
                <div className={`utr-card event-card event-card-featured ${hasBackgroundImage() ? 'has-background-image' : ''}`}>
                    <div
                        className={`card-view left-gradiant ${colorState()} ${force && force.small ? 'card-small' : ''}`}
                        ref={this.refCallback}
                    >

                        <div className="d-flex flex-row">
                            <div className="left-column">
                                <div className="tag-container mb-auto">
                                    <div className={`tag tag-featured tag-sm mr8`}>Featured</div>
                                    {getTag()}
                                </div>
                                {/* club && club.name && !(force && force.small) && (
                                    <div className="club-name show-ellipsis mb8">
                                        {club.name}
                                    </div>
                                ) */}
                                <div className="h6 event-name">
                                    {eventName}<span className={`${utrType && utrType.value === 'sanctioned' ? 'sanctioned' : ''}`} />
                                </div>
                                {!(force && force.small) && (
                                    <div className="event-details show-ellipsis">
                                        <Description desc={descriptionItems} />
                                    </div>
                                )}
                            </div>
                            <div className="right-column">
                                <BackgroundImage
                                    baseUrl={'/v1/tms/events/'}
                                    defaultImage={''}
                                    images={photoImages}
                                    imageType={'dashboard'}
                                    style={{ width: '100%', height: '100%' }}
                                    backgroundOverlay={hasBackgroundImage()}
                                >
                                    <div className={`right-wrapper`}>
                                        <div className="bookmark">
                                            {(featureFlags.bookmarks.isEnabled(auth.user)) && <i className="utr utr-bookmark" />}
                                        </div>
                                        <div className="event-schedule mt-auto">
                                            <div className="month">
                                                {getEventMonths(eventSchedule)}
                                            </div>
                                            <div className="day">
                                                {getEventDates(eventSchedule)}
                                            </div>
                                        </div>
                                    </div>
                                </BackgroundImage>
                            </div>
                        </div>
                    </div>
                </div>
            </LinkAnchor>
        );
    }
}

export default withFeatureFlags(FeaturedEventCard);
